import { render, staticRenderFns } from "./PennStateDadosVisita.vue?vue&type=template&id=097a53f1&"
import script from "./PennStateDadosVisita.vue?vue&type=script&lang=js&"
export * from "./PennStateDadosVisita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports